import script from "./Withdrawals.vue?vue&type=script&setup=true&lang=ts"
export * from "./Withdrawals.vue?vue&type=script&setup=true&lang=ts"

import "./Withdrawals.vue?vue&type=style&index=0&id=d88ff060&lang=css"

const __exports__ = script;

export default __exports__